import * as ko from "knockout";
import entityBase from "entityBase";

export class searchCriteriaItem<T> {
  value: KnockoutObservable<T>;
  readonly: KnockoutObservable<boolean>;

  constructor(params: searchCriteriaItem<T> | any) {
    this.value = ko.observable(params?.value);
    this.readonly = ko.observable(params?.readonly ?? false);
  }
}

export class searchCriteriaComplex extends entityBase {
  Page: KnockoutObservable<number>;
  Rows: KnockoutObservable<number>;
  sort_dir: KnockoutObservable<string>;
  sort_field: KnockoutObservable<string>;
  isExport: KnockoutObservable<boolean>;
  generalSearch: searchCriteriaItem<string>;

  created_dttm_from: searchCriteriaItem<Date>;
  created_dttm_to: searchCriteriaItem<Date>;

  constructor(item?: any) {
    super();
    this.Page = ko.observable(item?.Page || 0);
    this.Rows = ko.observable(item?.Rows || 15);
    this.sort_dir = ko.observable(item?.sort_dir);
    this.sort_field = ko.observable(item?.sort_field);
    this.isExport = ko.observable(item?.isExport || false);
    this.generalSearch = new searchCriteriaItem<string>({ value: item?.generalSearch });
    this.created_dttm_from = new searchCriteriaItem<Date>({ value: this.formatJSONDate(item.created_dttm_from) });
    this.created_dttm_to = new searchCriteriaItem<Date>({ value: this.formatJSONDate(item.created_dttm_to) });
  }

  toJSON = () => {
    let result = {};

    Object.keys(this).map((key) => {
      if (this[key]?.value && !this[key]?.readonly()) {
        result[key] = this[key]?.value();
      }

      if (ko.isObservable(this[key])) {
        result[key] = this[key]();
      }
    });
    return ko.toJSON(result);
  };
}
